// extracted by mini-css-extract-plugin
module.exports = {"container":"FoodsList_container__2D3xX","wrapper":"FoodsList_wrapper__1qPDe","no":"FoodsList_no__aJhSK","grid":"FoodsList_grid__AM8Va"};